/* eslint-disable max-lines */
/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.PrivacyConsent,
        questionText: "I have provided the employee I am referring with access to the <strong><u><a href=\"https://www.tphealth.co.uk/privacy-statement\" target=\"_blank\" rel=\"noopener noreferrer\">Optima Health Privacy Statement</a></u></strong> which clearly explains in detail how, where and when their personal and health data will be processed.",
        canBeDisabled: true
    },
    {
        id: questionIds.EmployeeAwareConsent,
        questionText: "In ticking this box, I confirm that I have made the employee aware that I am making this referral and I can confirm that the employee is aware of the purpose and content of the referral.",
        canBeDisabled: true
    },
    {
        id: questionIds.DataSecureConsent,
        questionText: "I understand that all information about the employee I am referring will be held securely and if the employee wishes to gain access to their medical information they can do so by requesting access in writing to Optima Health.",
        canBeDisabled: true
    },
    {
        id: questionIds.LineManagerName,
        questionText: "Line Manager's Name",
        canBeDisabled: false
    },
    {
        id: questionIds.LineManagerEmail,
        questionText: "Line Manager's Email",
        canBeDisabled: false
    },
    {
        id: questionIds.LineManagerPhone,
        questionText: "Line Manager's Telephone",
        canBeDisabled: false
    },
    {
        id: questionIds.HrName,
        questionText: "HR Representative's Name",
        canBeDisabled: false
    },
    {
        id: questionIds.HrEmail,
        questionText: "HR Representative's Email",
        canBeDisabled: false
    },
    {
        id: questionIds.PurchaseOrderNumber,
        questionText: "Purchase Order Number",
        canBeDisabled: true,
        disabled: true
    },
    {
        id: questionIds.ReferredTitle,
        questionText: "Title",
        canBeDisabled: true
    },
    {
        id: questionIds.ReferredFirstName,
        questionText: "First Name",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredLastName,
        questionText: "Last Name",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredDob,
        questionText: "Date of Birth",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredGender,
        questionText: "Gender",
        canBeDisabled: true
    },
    {
        id: questionIds.EmployeeId,
        questionText: "Employee Unique Id",
        canBeDisabled: false
    },
    {
        id: questionIds.JobTitle,
        questionText: "Job Role/Title",
        canBeDisabled: true
    },
    {
        id: questionIds.AddressLine1,
        questionText: "Address Line 1",
        canBeDisabled: true
    },
    {
        id: questionIds.AddressLine2,
        questionText: "Address Line 2",
        canBeDisabled: true
    },
    {
        id: questionIds.AddressLine3,
        questionText: "Address Line 3",
        canBeDisabled: true
    },
    {
        id: questionIds.City,
        questionText: "City",
        canBeDisabled: true
    },
    {
        id: questionIds.County,
        questionText: "County",
        canBeDisabled: true
    },
    {
        id: questionIds.Postcode,
        questionText: "Postcode",
        canBeDisabled: false
    },
    {
        id: questionIds.PersonalEmailAddress,
        questionText: "Email (Work or Personal)",
        canBeDisabled: false
    },
    {
        id: questionIds.ConfirmPersonalEmailAddress,
        questionText: "Confirm email address",
        canBeDisabled: false
    },
    {
        id: questionIds.MobilePhone,
        questionText: "Mobile Telephone",
        canBeDisabled: true
    },
    {
        id: questionIds.HomePhone,
        questionText: "Home Telephone",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkPhone,
        questionText: "Work Telephone",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel1Name,
        questionText: "Org Level 1",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel2Name,
        questionText: "Org Level 2",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel3Name,
        questionText: "Org Level 3",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel4Name,
        questionText: "Org Level 4",
        canBeDisabled: true
    },
    {
        id: questionIds.ShiftPattern,
        questionText: "Shift Pattern",
        canBeDisabled: true
    },
    {
        id: questionIds.StandardHours,
        questionText: "Standard Hours per Week",
        canBeDisabled: true
    },
    {
        id: questionIds.PrivateMedicalInsurance,
        questionText: "Standard Hours per Week",
        canBeDisabled: true
    },
    {
        id: questionIds.EmployeeAssistedProgramme,
        questionText: "Employee Assistance Programme",
        canBeDisabled: true
    },
    {
        id: questionIds.Physiotherapy,
        questionText: "Physiotherapy Access",
        canBeDisabled: true
    },
    {
        id: questionIds.Absent,
        questionText: "Is the Individual Currently Absent from Work?",
        canBeDisabled: true
    },
    {
        id: questionIds.AbsenceStart,
        questionText: "First Date of Absence",
        canBeDisabled: true
    },
    {
        id: questionIds.PreviouslyReferred,
        questionText: "Has the Individual Previously Been Referred to OH?",
        canBeDisabled: true
    },
    {
        id: questionIds.RestrictedDuties,
        questionText: "Is the individual currently on any form of restricted duties or phased return to work, either short term or long term?",
        canBeDisabled: true
    },
    {
        id: questionIds.RestrictedDutiesDetails,
        questionText: "Please outline any measures / adjustments that have already been introduced (i.e. temporary adjustments of hours). If there are any adjustments in the workplace that are likely to be able to facilitate the individual's rehabilitation back to work that you can or cannot accommodate please ensure that these are clearly indicated.",
        canBeDisabled: true
    },
    {
        id: questionIds.Recurrent,
        questionText: "Recurrent Short Spells of Absence Causing Commercial Harm",
        canBeDisabled: true
    },
    {
        id: questionIds.Prolonged,
        questionText: "Prolonged Sickness Absence (give date when absence commenced, and any diagnosis given)",
        canBeDisabled: true
    },
    {
        id: questionIds.MentalHealth,
        questionText: "Mental Health Condition (stress, anxiety, depression)",
        canBeDisabled: true
    },
    {
        id: questionIds.MusculoSkeletal,
        questionText: "Musculoskeletal Condition",
        canBeDisabled: true
    },
    {
        id: questionIds.FitnessForWork,
        questionText: "Fitness for Work",
        canBeDisabled: true
    },
    {
        id: questionIds.FitnessForDisciplinary,
        questionText: "Fitness to Attend Disciplinary Hearing/Meeting",
        canBeDisabled: true
    },
    {
        id: questionIds.Accident,
        questionText: "Assessment of Fitness Following an Accident at Work",
        canBeDisabled: true
    },
    {
        id: questionIds.RequirementsChanged,
        questionText: "Job Requirements will be Changing/Have Changed",
        canBeDisabled: true
    },
    {
        id: questionIds.PoorPerformance,
        questionText: "Poor Performance at Work",
        canBeDisabled: true
    },
    {
        id: questionIds.AlcoholOrDrugMisuse,
        questionText: "Suspect Alcohol or Drug Misuse",
        canBeDisabled: true
    },
    {
        id: questionIds.IllHealthRetirement,
        questionText: "Ill Health Retirement",
        canBeDisabled: true
    },
    {
        id: questionIds.AbsenceReason,
        questionText: "Please give the reason for absence including medical condition (depression, anxiety or musculoskeletal) and any further concerns you have.",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkRelated,
        questionText: "Is the ill health work related?",
        canBeDisabled: true
    },
    {
        id: questionIds.ReturnDate,
        questionText: "Likely date of return to work",
        canBeDisabled: true
    },
    {
        id: questionIds.RestrictionsApply,
        questionText: "Do any temporary or permanent restrictions apply? and if so, for how long?",
        canBeDisabled: true
    },
    {
        id: questionIds.AdjustmentsRequired,
        questionText: "Should there be any adjustments to their days/hours of work to help facilitate their return to work? and if so, how long would this adjustment to days/hours be required?",
        canBeDisabled: true
    },
    {
        id: questionIds.EqualityAct,
        questionText: "In your opinion, would this person's condition be covered by the Equality Act 2010? and if so, what adjustments should be considered? (Please note that this is purely an opinion and is ultimately a decision for the courts as to who is covered by the Equality Act 2010)",
        canBeDisabled: true
    },
    {
        id: questionIds.FitToContinue,
        questionText: "Is the individual fit to continue in their current post?",
        canBeDisabled: true
    },
    {
        id: questionIds.FitForDisciplinary,
        questionText: "Is the individual medically fit to attend disciplinary hearing/meeting?",
        canBeDisabled: true
    },
    {
        id: questionIds.ReliableInFuture,
        questionText: "Is the individual likely to render a reliable service and attendance in the future?",
        canBeDisabled: true
    },
    {
        id: questionIds.ImpairedPerformance,
        questionText: "Does the individual have a health condition that could lead to impaired performance? If so, in what areas and for how long is it likely to continue?",
        canBeDisabled: true
    },
    {
        id: questionIds.ReferToSpecialist,
        questionText: "Would a further referral to a specialist (e.g. counselling/physiotherapy) aid the individual's recovery?",
        canBeDisabled: true
    },
    {
        id: questionIds.AdditionalInfo,
        questionText: "Please provide any additional information required including any further questions that you have",
        canBeDisabled: true
    },
    {
        id: questionIds.FaceToFaceAttend,
        questionText: "If a face to face appointments is arranged I would like to attend the last 10 minutes of the appointment and I have consent from the employee to do this.",
        canBeDisabled: true,
        disabled: true
    },
    {
        id: questionIds.TelephoneDiscussion,
        questionText: "If a telephone appointment or video consultation is arranged I would like to the clinician to ring me at the end of the consultation to discuss any adjustments.  I understand I must make myself available for the phone call and that the Clinician will only have 5 minutes available for the call.",
        canBeDisabled: true,
        disabled: true
    },
    {
        id: questionIds.ProlongedStanding,
        questionText: "Prolonged Standing",
        canBeDisabled: true
    },
    {
        id: questionIds.ProlongedSitting,
        questionText: "Prolonged Sitting",
        canBeDisabled: true
    },
    {
        id: questionIds.Driving,
        questionText: "Driving",
        canBeDisabled: true
    },
    {
        id: questionIds.Walking,
        questionText: "Walking",
        canBeDisabled: true
    },
    {
        id: questionIds.Climbing,
        questionText: "Climbing",
        canBeDisabled: true
    },
    {
        id: questionIds.ShiftWork,
        questionText: "Exposure to Night/Shift Work",
        canBeDisabled: true
    },
    {
        id: questionIds.HeavyLifting,
        questionText: "Lifting or Carrying Heavy Items",
        canBeDisabled: true
    },
    {
        id: questionIds.Twisting,
        questionText: "Twisting",
        canBeDisabled: true
    },
    {
        id: questionIds.Pulling,
        questionText: "Pulling",
        canBeDisabled: true
    },
    {
        id: questionIds.Pushing,
        questionText: "Pushing",
        canBeDisabled: true
    },
    {
        id: questionIds.Dse,
        questionText: "Computer Work/Display Screen Equipment",
        canBeDisabled: true
    },
    {
        id: questionIds.ConfinedSpace,
        questionText: "Working in Confined Space",
        canBeDisabled: true
    },
    {
        id: questionIds.Chemicals,
        questionText: "Working with Chemicals",
        canBeDisabled: true
    },
    {
        id: questionIds.BiologicalAgents,
        questionText: "Working with Biological Agents",
        canBeDisabled: true
    },
    {
        id: questionIds.Machinery,
        questionText: "Working with Machinery",
        canBeDisabled: true
    },
    {
        id: questionIds.DustOrFumes,
        questionText: "Working with Dust or Fumes",
        canBeDisabled: true
    },
    {
        id: questionIds.NoiseHazards,
        questionText: "Exposure to Noise Hazards",
        canBeDisabled: true
    },
    {
        id: questionIds.OutsideWork,
        questionText: "Outside Work",
        canBeDisabled: true
    },
    {
        id: questionIds.OverseasTravel,
        questionText: "Occasional Overseas Travel",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkplaceStress,
        questionText: "Exposure to Workplace Stress (Deadlines/Targets)",
        canBeDisabled: true
    },
    {
        id: questionIds.OtherRoleFunctions,
        questionText: "Please state any other functions of the individual's role that are not included above",
        canBeDisabled: true
    },
    {
        id: questionIds.TotallyConfidential,
        questionText: "Mark as totally confidential",
        canBeDisabled: true
    },
    {
        id: questionIds.SeparateAdditionalQuestionAnswersRequired,
        questionText: "SeparateAdditionalQuestionAnswersRequired",
        canBeDisabled: false
    },
    {
        id: questionIds.SupportingDocumentsHeader,
        questionText: "Please attach any further relevant information such as absence history or completed risk assessments here to support your referral.  Please note, any uploaded documents will show on the documents tab in the case after submission.",
        canBeDisabled: false
    }
];
/* eslint-enable max-len */
/* eslint-enable max-lines */
